import { FunctionComponent, memo } from 'react';

import { StoryCard, StoryCardType } from '../../../services';
import { Article } from './Article';
import { Editorial } from './Editorial';
import { Event } from './Event';
import { Media } from './Media';
import { Poll } from './Poll';
import { Post } from './Post';
import { Social } from './Social';
import { Thread } from './Thread';

export interface RightSideStoryCardProps {
  card: StoryCard;
}

export const RightSideStoryCard: FunctionComponent<RightSideStoryCardProps> = memo(({ card }) => {
  switch (card.type) {
    case StoryCardType.IMAGE:
    case StoryCardType.AUDIO:
    case StoryCardType.VIDEO:
    case StoryCardType.PDF:
      return <Media card={card} />;
    case StoryCardType.EDITORIAL:
      return <Editorial card={card} />;
    case StoryCardType.EVENT:
      return <Event card={card} />;
    case StoryCardType.THREAD:
      return <Thread card={card} />;
    case StoryCardType.QUOTE:
      return <Social card={card} />;
    case StoryCardType.ARTICLE:
      return <Article card={card} />;
    case StoryCardType.POST:
      return <Post card={card} />;
    case StoryCardType.POLL:
      return <Poll card={card} />;
    default:
      return null;
  }
});
